import React from 'react';
import { TrendingUp } from 'lucide-react';

export const CaseStudyCard = ({ study, testId }) => (
  <article
    data-testid={testId}
    className="group flex h-full flex-col justify-between rounded-[16px] border border-[color:var(--rmh-border)] p-7 transition-[box-shadow,transform,border-color] duration-500 hover:-translate-y-[2px] hover:border-[color:var(--rmh-border-strong)]"
    style={{
      backgroundColor: 'var(--rmh-surface)',
      boxShadow: 'var(--shadow-hairline)',
    }}
  >
    <div>
      <div className="flex items-center justify-between gap-3">
        <span className="rmh-eyebrow text-[0.58rem]">{study.tag}</span>
        <TrendingUp
          className="h-4 w-4"
          strokeWidth={1.4}
          style={{ color: 'var(--rmh-accent)' }}
          aria-hidden="true"
        />
      </div>

      <p
        className="rmh-num mt-6 text-[2rem] leading-none"
        style={{ color: 'var(--rmh-border-strong)' }}
        aria-hidden="true"
      >
        {study.metric}
      </p>

      <h3 className="mt-5 font-serif text-[1.1rem] leading-snug text-[color:var(--rmh-ink)]">
        {study.title}
      </h3>
      <p className="rmh-body mt-3 text-[0.875rem]">{study.body}</p>
    </div>

    <div className="mt-7">
      <div className="rmh-rule" />
      <p className="mt-4 text-[0.72rem] uppercase tracking-[0.16em] text-[color:var(--rmh-muted-2)]">
        {study.status}
      </p>
    </div>
  </article>
);

export default CaseStudyCard;
